import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';
import '../../components/default.css';
import { listAllProject, getProject } from '../../redux/projects/projects_actions';
import SummaryCard from '../../components/summarycard/SummaryCard';
import SavingEnergyConsumptionChart from '../../components/powerconsumptionchart/SavingEnergyConsumptionChart';
import ProjectList from '../../components/projectlist/ProjectList';
import Layout from '../../components/layout/Layout';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,
    };
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.props.listProject(page, pageSize);
  }

  render() {
    const { projects, t } = this.props;
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const breadcrumbItems = [{ name: t('dashboard'), path: '/dashboard' }];

    const summaryItems = [
      {
        title: t('total projects'),
        number: this.props.totalCount || 0,
        unit: t('projects'),
        iconClass: 'fas fa-folder fa-3x',
      },
      {
        title: l('โครงการประเมินแล้วเสร็จ', 'Completed projects'),
        number: this.props.submittedCount || 0,
        unit: t('projects'),
        iconClass: 'fas fa-check fa-3x',
      },
    ]
      // Only show the first two cards (hide items 2 and 3 from the original set)
      .map(item => ({ ...item, number: getFormatter(FORMATTER_STYLE.decimal)(item.number) }));

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
      >
        <Grid>
          <Row>
            {summaryItems.map((item, index) => (
              <Col xs={12} sm={6} md={6} key={index}>
                <SummaryCard {...item} />
              </Col>
            ))}
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <ProjectList
                projects={projects || []}
                limit={this.state.pageSize}
                offset={this.state.page * this.state.pageSize}
                limitOptions={[10, 20, 50, 100]}
                total={this.props.filteredCount || (projects ? projects.length : 0)}
                onPageChange={({ limit, offset }) => {
                  const pageSize = limit;
                  const page = Math.max(0, Math.floor((offset || 0) / pageSize));
                  this.setState({ page, pageSize }, () => {
                    this.props.listProject(this.state.page, this.state.pageSize);
                  });
                }}
              />
            </Col>
            {/* Hide the right-side chart (item 5) */}
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
  totalCount: state.project.totalCount,
  submittedCount: state.project.submittedCount,
  filteredCount: state.project.filteredCount || state.project.totalCount,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listProject: (page, pageSize) => dispatch(listAllProject(page, pageSize)),
  getProject: id => dispatch(getProject(id)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DashboardPage)
);



// WEBPACK FOOTER //
// ./src/pages/dashboard/DashboardPage.js